import { createContext, Dispatch, useContext, useReducer } from "react";
import { ActionMap } from "./ActionMap";

type InitialStateType = {
  deleteId: number;
};

export const DeleteResourceContext = createContext<{
  state: InitialStateType;
  dispatch: Dispatch<Actions>;
}>({
  state: { deleteId: 0 },
  dispatch: () => null,
});

export enum DeleteResourceActionTypes {
  SetDeleteId = "SET_DELETE_ID",
}

export const DeleteResourceContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, dispatch] = useReducer(deleteResourceReducer, { deleteId: 0 });

  return <DeleteResourceContext.Provider value={{ state, dispatch }}>{children}</DeleteResourceContext.Provider>;
};

export const useDeleteResourceActions = () => {
  const { dispatch } = useContext(DeleteResourceContext);

  return {
    setDeleteResource: (deleteId: number) => deleteResourceActions.setDeleteResource(dispatch, deleteId),
  };
};
type Payload = {
  [DeleteResourceActionTypes.SetDeleteId]: number;
};

export type Actions = ActionMap<Payload>[keyof ActionMap<Payload>];

export const deleteResourceReducer = (state: InitialStateType, action: Actions): InitialStateType => {
  switch (action.type) {
    case DeleteResourceActionTypes.SetDeleteId:
      return { ...state, deleteId: action.payload };

    default:
      return state;
  }
};

export const deleteResourceActions = {
  setDeleteResource: (dispatch: Dispatch<Actions>, deleteId: number) =>
    dispatch({
      type: DeleteResourceActionTypes.SetDeleteId,
      payload: deleteId,
    }),
};
